import { JSX } from 'react';

import { ESortOptions } from './filter-sessions';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

const SORT_OPTIONS: Record<ESortOptions, { label: JSX.Element; value: ESortOptions }> = {
  [ESortOptions.upcoming]: {
    label: <div className="flex ai-center jc-center gap-4">Upcoming</div>,
    value: ESortOptions.upcoming,
  },
  [ESortOptions.datedesc]: {
    label: <div className="flex ai-center jc-center gap-4">Newest</div>,
    value: ESortOptions.datedesc,
  },
  [ESortOptions.dateasc]: {
    label: <div className="flex ai-center jc-center gap-4">Oldest</div>,
    value: ESortOptions.dateasc,
  },
  [ESortOptions.az]: {
    label: (
      <div className="flex ai-center jc-center gap-4">
        <span>A</span> <Icon name={ICONS.ARROW_RIGHT} size={12} /> <span>Z</span>
      </div>
    ),
    value: ESortOptions.az,
  },
  [ESortOptions.za]: {
    label: (
      <div className="flex ai-center jc-center gap-4">
        <span>Z</span> <Icon name={ICONS.ARROW_RIGHT} size={12} /> <span>A</span>
      </div>
    ),
    value: ESortOptions.za,
  },
};

export default SORT_OPTIONS;
